<template>
  <div class="row">
    <div class="col-sm-12 col-md-4 offset-md-4 login-form mx-auto p-5">
      <div class="p-3">
        <img src="~../assets/image/logo_L_size.png" width="100%" />
      </div>
      <div class="row">
        <div class="col-12 col-md-12">
          <form class="form-custom" style="min-width: auto; ">
            <label for="inputEmail" class="sr-only">{{ $t('username') }}</label>
            <input type="email" class="form-control rounded" :placeholder="$t('username')" required autofocus v-model="account">
            <label for="inputPassword" class="sr-only">{{ $t('password') }}</label>
            <input type="password" class="form-control mt-3 rounded" :placeholder="$t('password')" required v-model="password">
            <button class="btn btn-lg btn-primary btn-block mt-5" @click.stop.prevent="login()">{{ $t('login') }}</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import menu from '../menu'
  import { mapGetters, mapActions } from 'vuex'
  import { apiPath } from '../store/api'

  export default {
    name: 'Login',

    data () {
      return {
        account: '',
        password: ''
      }
    },

    computed: {
      ...mapGetters([
        'userRole',
        'authorized'
      ])
    },

    methods: {
      ...mapActions({
        dologin: 'login'
      }),

      async login () {
        await this.dologin({ account: this.account, password: this.password })

        this.$nextTick(() => {
          for (var first in menu[this.userRole]) {
            break
          }

          this.$router.push('/' + first)
        })
      },

      openISchoolUrl () {
        window.open(apiPath + '/Auth/ischool', '_self')
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../assets/style/color.scss';
</style>



// WEBPACK FOOTER //
// Login.vue?37208fab